module.exports = __webpack_public_path__ + "static/media/eimi-fukada-lesb.98af47f6.jpg";